import 'bootstrap/dist/css/bootstrap.min.css';
import {useLayoutEffect} from 'react';
import {I18nextProvider} from 'react-i18next';
import ReactModal from 'react-modal';
import {useSelector} from 'react-redux';
import {BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import Message from './components/alert/Message';
import CookieBanner from './components/cookie/CookieBanner';
import Footer from './components/footer/Footer';
import Header from './components/header/Header';
import {IconLogo} from './components/icons/Icon.tsx';
import LoaderOverlay from './components/loader/LoaderOverlay';
import {getJsonDataNoError} from './fetch/requests';
import i18n from './i18n/i18n';
import ApplicationLauncher from './pages/applications/ApplicationLauncher';
import Login from './pages/login/Login';
import ForgotPassword from './pages/password/ForgotPassword';
import SetNewPassword from './pages/password/SetNewPassword';
import EditProfile from './pages/profile/EditProfile';
import {loginAction, logoutAction} from './redux/action/loginAction';
import {useAppDispatch} from './redux/hooks';
import './App.scss';
import {RootState} from './redux/rootReducer';

function App() {
    const root = document.getElementById('root');
    if (root) {
        ReactModal.setAppElement(root);
    }

    const showLoader = useSelector((state: RootState) => state.loader.show);
    const message = useSelector((state: RootState) => state.message.message);
    const loginStateRequested = useSelector((state: RootState) => state.login.requested);
    const loggedIn = useSelector((state: RootState) => state.login.loggedIn);

    const dispatch = useAppDispatch();

    useLayoutEffect(() => {
        if (!loginStateRequested) {
            getJsonDataNoError('api/1.0/accounts/me', dispatch).then(json => {
                return dispatch(loginAction(json.result));
            }).catch(() => {
                dispatch(logoutAction());
            });
        }
    }, [loginStateRequested, dispatch]);

    return (
        <I18nextProvider i18n={i18n}>
            <LoaderOverlay showLoader={showLoader}/>
            {
                loginStateRequested &&
                <BrowserRouter>
                    {
                        loggedIn &&
                        <Header/>
                    }

                    <div className="content">
                        <div className="content-wrapper">
                            <div className="logo-container">
                                <IconLogo className="sc-logo"/>
                            </div>
                            <div className="content-card">
                                {
                                    message &&
                                    <Message {...message}/>
                                }
                                <Routes>
                                    <Route path="/login" element={!loggedIn ? <Login/> : <Navigate to="/applications" replace/>}/>
                                    <Route path="/forgot-password" element={<ForgotPassword/>}/>
                                    <Route path="/set-password/:token" element={<SetNewPassword/>}/>
                                    <Route path="/applications" element={loggedIn ? <ApplicationLauncher/> : <Navigate to="/login" replace/>}/>
                                    <Route path="/edit-profile" element={loggedIn ? <EditProfile/> : <Navigate to="/login" replace/>}/>
                                    {/* Default route - redirect to login */}
                                    <Route path="*" element={<Navigate to="/login" replace/>}/>
                                </Routes>
                            </div>
                        </div>
                    </div>
                    <CookieBanner/>
                    <Footer/>
                </BrowserRouter>
            }
        </I18nextProvider>
    );
}

export default App;
